import { useRef, useEffect, useState } from 'react';
import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import '../MCPServerSetting.css';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { renderSettingApiStatus, renderSettingMCPServer } from '../handler/MCPServerUIHandler';
import { createNewInitApiData, transformApiDataClient, handleUpdateMCPServerByAction, getMCPServerById } from '../handler/MCPServerLogicHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { closeTabId, multiPanelAtom} from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';

MCPServerList.propTypes = {
    panelType: PropTypes.string,
    listSettingApi: PropTypes.array,
    setListSettingApi: PropTypes.func,
    setEditApiData: PropTypes.func,
    setIsLoading: PropTypes.func,
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    userDetail: PropTypes.object,
    props: PropTypes.object
};

function MCPServerList({
    setIsLoading,
    panelType,
    listSettingApi,
    setListSettingApi,
    setEditApiData,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    props
}) {
    const mcpServerListBody = useRef(null);
    const [isShowPopUpReload, setIsShowPopUpReload] = useState(false);
    
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    const callActiveInOrg = (activeValue, mcpServerData) => {
        let mcpData = {
            id: mcpServerData.id,
            isActiveCorp: activeValue
        };

        handleUpdateSuccess(null, mcpServerData, activeValue)
        setIsLoading(true);
        handleUpdateMCPServerByAction(
            Constant.MCP_SERVER_UPDATE_ACTION_TYPE.TOGGLE_ACTIVE_IN_ORG,
            mcpData,
            {
                corporationInuse: corporationDetail.id,
                projectInuse: projectInuseDetail.id,
                userId: userDetail.id,
                panelType
            }
        )
            .then(response => handleUpdateSuccess(response, mcpServerData, activeValue))
            .catch(err => {
                console.log('handleUpdateMCPServerByAction err: ', err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleUpdateSuccess = (response, mcpServerData, isActiveCorp) => {
        if (!Utils.isEmptyString(response?.error)) {
            if (response?.error === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                setIsShowPopUpReload(true);
            }
        }
        setListSettingApi(prev =>
            prev.map(item => (item.id === mcpServerData?.id ? { ...item, isActiveCorp } : item))
        );
    };

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
            if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
            closePanelTab({
                event: null,
                panelType: currentPanelInfo.type,
                panelId: props.panelId,
                tabId: props.tabId
            });
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const handleOpenDetail = async apiData => {
        setIsLoading(true);
        getMCPServerById(apiData)
            .then(response => {
                const { mcpServerDetail, error } = response;
                if (!Utils.isEmptyString(error)) {
                    if (error === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                        setIsShowPopUpReload(true);
                        return;
                    }
                }
                setEditApiData(transformApiDataClient(mcpServerDetail));
            })
            .catch(err => {
                console.log('callActiveInOrg err: ', err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div style={{ height: '100%' }}>
            <div className="mcp-server-header mcp-server-line-space">
                <div className="mcp-server-header-inner">
                    <h3 className="mcp-server-setting-list">
                        {I18n.get('MCP_SERVER_SETTING_LIST_ORG')}
                    </h3>
                    <button
                        className="add-more-mcp-server-btn"
                        onClick={() => setEditApiData(createNewInitApiData())}
                    >
                        <img
                            className="add-more-mcp-server-icon"
                            src="/assets/image/icon-plus-add.svg"
                            alt="icon-plus-add"
                        />
                    </button>
                </div>
            </div>
            <div className="mcp-server-body">
                <div className="mcp-server-body-line mcp-server-line-space mcp-server-body-line-org">
                    <div className="">
                        <h4>{I18n.get('MCP_SERVER_SETTING_LABEL_ORG')}</h4>
                    </div>
                    <div className="mcp-server-last-title">
                        <h4>{I18n.get('MCP_SERVER_SETTING_ACTIVE_IN_ORG')}</h4>
                    </div>
                    <div className="mcp-server-last-title">
                        <h4>{I18n.get('MCP_SERVER_SETTING_STATUS')}</h4>
                    </div>
                </div>
                <div className="mcp-server-list" ref={mcpServerListBody}>
                    {!Utils.isEmptyArray(listSettingApi) &&
                        listSettingApi.map(apiData => (
                            <div key={apiData.id} className="mcp-server-body-line mcp-server-line mcp-server-body-line-org">
                                <button
                                    className="mcp-server-item btn-reset-default"
                                    onClick={() => {
                                        handleOpenDetail(apiData);
                                    }}
                                >
                                    <OverFlowTooltipWithTabsMui value={Utils.serverNameWithPrefix(apiData.serverName, apiData.type)} />
                                </button>
                                {renderSettingMCPServer(apiData.isActiveCorp, callActiveInOrg, apiData, apiData.isActiveCorp)}
                                {renderSettingApiStatus(apiData.status)}
                            </div>
                        ))}
                </div>
            </div>
            <ConfirmDialog
                isOpen={isShowPopUpReload}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
        </div>
    );
}

export default MCPServerList;
